module.exports = __webpack_public_path__ + "static/media/CLEANING_PLEDGE_ICON.cb7d3c35.png";